module.exports = __webpack_public_path__ + "static/MUSEUMTV-462a9c93c21792adfd0ddbeb502747ef.png";